import React from 'react';
import { CircularProgress, createStyles, Grid, makeStyles, Theme, Typography } from '@material-ui/core';

interface ITableLoadingProps {
    displayText: string
}

const useStyles = makeStyles((theme: Theme) => createStyles({
    item: {
        margin: theme.spacing(4),
        maxWidth: '730px',
        textAlign: 'center'
    }
}));

export function TableLoading({ displayText }: ITableLoadingProps) {
    const classes = useStyles();

    return (
        <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
        >
            <CircularProgress 
                color="primary" 
                size="124px" 
                className={classes.item} 
            />  
            <Typography 
                variant="h5" 
                className={classes.item}
            >
                { displayText }
            </Typography>          
        </Grid>
    );
}